import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const suggestedActionsLightbox = () =>
  import(/* webpackChunkName: "4-feat-suggested-actions-lightbox" */ './SuggestedActionsLightbox');

const LoadableSuggestedActionsLightbox: ComponentType = lazyLoadOnRender({ loader: suggestedActionsLightbox });
export default LoadableSuggestedActionsLightbox;
